module.exports = __webpack_public_path__ + "static/media/dum-dum-logo.fbfeaa8e.png";